export default "__VITE_ASSET__BU_0StQ9__"